import React, {useEffect} from 'react';
import {Box, Button, Card, CardContent, Grid, Typography} from '@deere/fuel-react';
import {getCategoryTotal, getCategoryWeightTotal, getTotalSelected} from "../shared/utils";
import {useStyles} from "../shared/styles/Summary";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export const RatingProgramReview = ({currentData, onEdit, onSelectStep}) => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState('');
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const onHandleEdit = (stepId, categoryId, categoryName) => {
        onEdit(stepId, categoryId, categoryName)
    }

    useEffect(() => {
        onSelectStep(2);
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    []);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box mt={6} mr={6} mb={2}>
                    <Card>
                        <CardContent style={{padding: 0}}>
                            <Box m={4}>
                                <Grid container alignItems="flex-start" spacing={1}>
                                    <Grid item xs={12}>
                                        <Box m={3}>
                                            <Typography variant="h3">
                                                Summary
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box mt={2} mr={6} mb={2}>
                    {currentData.category.map((item, index) => {
                            return (
                                <CardContent style={{padding: 0, marginTop: 5}} key={index}>
                                    <div className={classes.root}>
                                        <Accordion expanded={expanded === `panel${item.id}`}
                                                   onChange={handleChange(`panel${item.id}`)}>
                                            <Box m={2}>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <Box mb={-2} mr={2} mt={2} height={20} display="flex" justifyContent="flex-end">
                                                            <Button variant="text"
                                                                    onClick={() => onHandleEdit(1, item.id, item.description)}
                                                                    style={{float: 'right'}}>Edit</Button>
                                                        </Box>
                                                        <AccordionSummary
                                                            className={classes.accordionSummary}
                                                            classes={{
                                                                expandIcon: classes.expandIcon,
                                                                expanded: classes.expanded
                                                            }}
                                                            expandIcon={<ExpandMoreIcon
                                                                style={{fontSize: '2rem'}}/>}
                                                            aria-controls="panel1bh-content"
                                                            id="panel1bh-header"
                                                        >
                                                            <Grid container>
                                                                <Grid item xs={10}>
                                                                    <Box ml={3} mr={3} mb={3}>
                                                                        <Typography variant="h3">
                                                                            {item.description}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid item xs={1}>
                                                                    <Box ml={3} mr={3} mb={3} display="flex"
                                                                         justifyContent="center">
                                                                        <Typography variant="h3">
                                                                            {getCategoryTotal(currentData, item.id)}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid item xs={1}>
                                                                    <Box ml={3} mr={3} mb={3} display="flex"
                                                                         justifyContent="center">
                                                                        <Typography variant="h3">
                                                                            {`${getCategoryWeightTotal(currentData, item.id)}%`}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                {item.subCategories.map((subcat, index) => {
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            <Grid item xs={10}>
                                                                                <Box ml={3} mr={3} mb={3}>
                                                                                    <Typography variant="h5">
                                                                                        {subcat.description}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                            <Grid item xs={1}>
                                                                                <Box ml={3} mr={3} mb={3} display="flex"
                                                                                     justifyContent="center">
                                                                                    <Typography variant="h5">
                                                                                        {getTotalSelected(currentData, subcat.id)}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                            <Grid item xs={1}>
                                                                                <Box ml={3} mr={3} mb={3} display="flex"
                                                                                     justifyContent="center">
                                                                                    <Typography variant="h5">
                                                                                        {`${subcat.weight}%`}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </Grid>
                                                        </AccordionSummary>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Accordion>
                                    </div>
                                </CardContent>
                            )
                        }
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};
